import React from 'react';
import classnames from 'classnames';
import jsCookie from 'js-cookie';
import { useMemoizedFn } from 'ahooks';
import { SimpleButton } from '@/components/Simple/SimpleButton';
import { authCookieDomain, ieltsNextWeb } from '@/utils/env';
import { UserInfo } from '@/modules/UserInfo/lazy';
import { useAppSelector } from '@/stores';
import i18n from '@/locales/init';
import { Breadcrumb } from '../Breadcrumb/';
import css from './home.header.module.less';

export const HomeHeader = () => {
  const { backUrl } = useAppSelector(state => state.homeHeader);
  const switchToNewVersion = useMemoizedFn(() => {
    jsCookie.set('VERSION', 'v1', { domain: authCookieDomain });
    window.location.href = ieltsNextWeb;
  });

  return (
    <div className={classnames(css['container'])}>
      <div className={classnames(css['left'])}>
        <Breadcrumb />
        {
          backUrl && (
            <SimpleButton duyan_type='dashed' className={css['back-btn']} onClick={()=>{
              window.location.href = backUrl;
            }}>返回</SimpleButton>
          )
        }
      </div>
      <div className={classnames(css['right'])}>
        <SimpleButton data-track-key="switch-version-new" style={{ marginRight: '10px' }} duyan_type='standard' onClick={switchToNewVersion}>{i18n.t('使用新版')}</SimpleButton>
        <UserInfo />
      </div>
    </div>
  );
};